module.exports = __webpack_public_path__ + "static/img/1080.98be440.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1080.jpg
// module id = 262
// module chunks = 0